<template class="ml-10">

  <el-popover trigger="hover" width="300px" placement="bottom-start">
    <slot name="hoverRef" slot="reference"></slot>
    <div class="mb-10">
      <a class="black-text" :href="filePath" style="text-decoration: underline;">Download example csv</a>
    </div>
  </el-popover>

</template>

<script>

export default {
  name: 'BulkExample',
  props: {
    filePath: {required: true}
  }
}


</script>
